export const UNCATEGORIZED_VALUE = ''
export const UNCATEGORIZED_LABEL = 'Uncategorized'
export const MIXED_CATEGORIES_LABEL = 'Mixed categories'
export const SECONDS = 1000;

/** Between names in a path: L1 › L2 › L3. */
export const PATH_SEP = ' › ';
/** Between a path and the field values that follow it. */
export const PART_SEP = ' · ';
/** Between groups on one line, e.g. each category merged into one. */
export const GROUP_SEP = ' | ';
/** Shown where a value is missing. */
export const NO_VALUE = '—';
/**
 * Operation Center URL for mithra staff
 */
export const STAFF_DEVOPS_CENTER_URL = 'https://operations-center.mithra-ai.nl/';
